module.exports = __webpack_public_path__ + "img/angellist.adeedb0d.svg";